import { SetupComplete } from '../components/SetupComplete';

export const DmOfferSetupComplete = () => <SetupComplete secondDevice />;
